import { ButtonProps as MuiButtonProps, IconButton as MuiIconButton, styled } from '@mui/material';
import React from 'react';
const PREFIX = 'IconButton';
const classes = {
  inputSize: `${PREFIX}-inputSize`,
};

type StyleProps = {
  size: 'small' | 'medium' | 'large';
};

type ButtonProps = MuiButtonProps & {
  setWidth?: boolean;
  mr?: number;
  ml?: number;
};

const StyledIconButton = styled(MuiIconButton, {
  shouldForwardProp: (props) => props !== 'setWidth',
})<StyleProps>(({ theme, size }) => ({
  alignItems: 'center',
  verticalAlign: 'middle',
  backgroundColor: theme.palette.lightBlue.o75,
  '&:hover': {
    backgroundColor: theme.palette.lightBlue.o75,
  },

  // [`& .${classes.inputSize}`]: ((size) => {
  //   switch (size) {
  //     case 'medium':
  //       return {
  //         height: '46px !important',
  //       };
  //     case 'small':
  //       return {
  //         height: 24,
  //       };
  //   }
  // })(size),
}));

const IconButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  fullWidth,
  size = 'small',
  color = 'inherit',
  mr = 2,
  ml = 0,
  sx,
  ...props
}) => {
  return (
    <StyledIconButton
      {...props}
      sx={{
        mr: mr,
        ml: ml,
        height: 32,
        width: 32,
        ...sx,
      }}
      classes={{
        root: classes.inputSize,
      }}
      size={size}
      color="inherit"
      onClick={onClick}>
      {children}
    </StyledIconButton>
  );
};

export default IconButton;
